import * as actions from "./actions";
import { exportEpic, importEpic } from "./middleware";
import { createNotificationsEpicForAction } from "./notification";
import { saveAs } from "file-saver";
import { fetchImportStdoutEpic, fetchExportStdoutEpic, refreshImportStdoutEpic, refreshExportStdoutEpic, closeStdoutEpic, } from "./importExport";
import { actionTypes } from "./actionTypes";
import { getData } from "./selector";
export const exportUrl = ({ scenario, wks, program, mode, binary, data, configuration, database, }) => `/api/v1/export/${scenario}/${wks}/${program}/${mode}?binary=${binary}&data=${data}&configuration=${configuration}&database=${database}`;
export const importUrl = ({ scenario, wks, program, mode, binary, data, database, configuration, cof, }) => `/api/v1/import/${scenario}/${wks}/${program}/${mode}?binary=${binary}&data=${data}&database=${database}&configuration=${configuration}&cof=${cof}`;
export const createImportExport = () => {
    const initialState = { info: "", infoType: 0 };
    function reducer(state = initialState, action) {
        switch (action.type) {
            case actionTypes.ADD_IMPORT_EXPORT_CHUNK:
                return Object.assign({}, state, {
                    info: action.payload.payloadInfo,
                    infoType: action.payload.payloadInfoType,
                });
            case actionTypes.CLEAN_IMPORT_EXPORT_CHUNK:
                return Object.assign({}, state, {
                    info: "",
                    infoType: 0,
                });
            default:
                return state;
        }
    }
    const middleware = [
        exportEpic(exportUrl, saveAs),
        importEpic(importUrl),
        createNotificationsEpicForAction(),
        fetchImportStdoutEpic,
        fetchExportStdoutEpic,
        refreshImportStdoutEpic,
        refreshExportStdoutEpic,
        closeStdoutEpic,
    ];
    const selectors = { getData };
    return { actions, reducer, middleware, selectors };
};
//# sourceMappingURL=index.js.map